















































































import Vue from 'vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import {
  DocuSignTemplateModel,
  DocuSignTemplateConfigurationModel,
  ArenaSignTemplateSearchModel,
  Dictionary,
  Configuration
} from '@/types';
import { RouteRegEx } from '@/types/enums';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import {
  ComponentHelper,
  MTablehelper,
  RouteHelpers,
  confirmationHelper,
  FormFieldValidation,
  ObjectHelper
} from '@/mixins';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  name: 'DocuSignTemplateSignHereManagement',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper, FormFieldValidation, ObjectHelper],
  data() {
    return {
      pageIsLoading: true,
      submitIsLoading: false,
      isLoading: false,
      fields: [
        {
          tabName: {
            label: 'Location',
            sortable: true
          }
        },
        {
          pageNumber: {
            label: 'Page Number',
            sortable: true
          }
        },
        {
          xCoord: {
            label: 'X Coordinate',
            sortable: true
          }
        },
        {
          yCoord: {
            label: 'Y Coordinate',
            sortable: true
          }
        },
        {
          'signerRole.description': {
            label: 'Signer',
            sortable: true
          }
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],

      hasError: false,
      errorMessage: '',
      docuSignTemplateConfigurationModel: {} as DocuSignTemplateConfigurationModel,
      docuSignTemplate: {} as DocuSignTemplateModel,
      tableStateKey: MTablehelper.Constants.TableStoreKeys.DocuSignTemplateSignHeres
    };
  },
  methods: {
    async getData(this: any) {
      this.isLoading = true;
      try {
        this.docuSignTemplatesConfigurationModel = await DocuSignConfigurationService.getTemplateConfigurationAsync({
          documentTypeId: this.documentTypeId,
          templateId: this.templateId
        } as ArenaSignTemplateSearchModel);
        this.docuSignTemplate = this.docuSignTemplatesConfigurationModel.template;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    navigateToEditTemplateSignHere(this: any, id: number) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.id = id;

      this.onTableStateFieldUpdated('selectedPk', id);
      this.$router.push({
        name: Configuration.DocuSign.TemplateSignHere.Edit.name,
        params: param
      });
    },
    navigateToAddTemplateSignHere() {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;

      this.$router.push({
        name: Configuration.DocuSign.TemplateSignHere.Add.name,
        params: param
      });
    },
    navigateToEditTemplate(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.id = this.templateId;

      this.$router.push({
        name: Configuration.DocuSign.Template.Edit.name,
        params: param
      });
    },
    async deleteTemplateSignHere(this: any, id: number) {
      const result = await this.hasDeleteConfirmedAsync(
        this.$bvModal,
        'Are you sure you want to delete the Sign Location?'
      );
      if (result) {
        try {
          this.isLoading = true;
          await DocuSignConfigurationService.deleteTemplateSignHereAsync(id);
          SnotifyConfiguration.showSuccess('Sign Location deleted successfully.');
          await this.getData();
        } catch (error) {
          this.$log('Error deleting Sign Location');
        } finally {
          this.isLoading = false;
        }
      }
    },
    resetViewState(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.DocuSignTemplateSignHeres);
      if (!canKeepState) {
        this.resetMTableState(this.tableStateKey);
      }
    },
    async initialise(this: any) {
      try {
        this.pageIsLoading = true;
        this.resetViewState();
        await this.getData();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.pageIsLoading = false;
      }
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    }
  },
  components: {
    MStoreTable,
    LoadingSpinner
  },
  mounted() {
    this.initialise();
  }
});
